<label
    class="control-label required-input"
    for="projectedCoordSystem"
    >Projected coordinate system</label
>
@if (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions) {
    <div
        class="input-group"
        data-test-automation="projected-coordinate-system">
        <ng-select
            class="nlr-ng-select"
            [searchable]="false"
            [clearable]="false"
            [disabled]="readonly || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions) || disableProjectedCoordSystem()"
            name="projectedCoordSystem"
            id="projectedCoordSystem"
            placeholder="Select"
            [items]="projectedCoordSystems"
            bindLabel="description"
            [ngModel]="getModel().spatialSettings?.projectedCoordSystem"
            (change)="projectedCoordSystemChange($event)">
        </ng-select>
    </div>
}
